import React, { useState, useEffect } from "react";
import "./crmTestimonial.css";
import client1 from "assets/realEstateCRM-image/client_1.png";
import client2 from "assets/realEstateCRM-image/client_2.png";
import reviewStar from "assets/realEstateCRM-image/star.svg";
import { useNavigate } from "react-router-dom";

// API
import { getQuery } from "api";
import { API_CHOOSE_PLAN } from "utils/apiEndPoints";

function CRMTestimonial() {
  const navigate = useNavigate();
  const [plans, setPlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState([]);
  const [billingCycle, setBillingCycle] = useState('monthly');

  const extractPrice = (billing_amount) => {
    return billing_amount;
  };

  const refresh = async () => {
    try {
      let currentPlans = plans;
      if(plans.length <= 0) {
          const response = await getQuery(API_CHOOSE_PLAN);
          if (response?.data?.success === 1) {
            setPlans(response?.data?.data?.package);
            currentPlans = response?.data?.data?.package;
          }
      }
      const filteredPlans = currentPlans.filter((plan) => {
        if (billingCycle === "monthly") {
          return plan.billing_frequency === "monthly";
        } else {
          return plan.billing_frequency === "yearly";
        }
      });
      setSelectedPlan(filteredPlans);
    } catch (error) {
      return console.log("error", error);
    }
  };

  useEffect(() => {
    refresh();
  }, [billingCycle]);

  const handleGetStart = (packageDetails) => {
    const billingAmount = extractPrice(packageDetails.billing_amount);
    navigate("/registration", {
      state: { billing_amount: billingAmount, package_id: packageDetails.id },
    });
  };

  const handleSwitch = (cycle) => {
    setBillingCycle(cycle);
  };

  return (
    <div className="crm-testimonial--outer">
      <div className="container">
        <button className="title-button title-button--secondary">Testimonial</button>
        <div className="crm-testimonial-content">
          <h3>Enhance Your Success with Our <br /> Outstanding Service</h3>
          <p>Discover Why Our Clients Rate Us for Exceptional Services and Unparalleled Results.</p>
        </div>
        <div className="crm-testimonial-comment">
          <div className="testimonial-comment">
            <div className="client-img">
              <img src={client1} alt="Nothing"></img>
            </div>
            <div className="client-content">
              <div className="star-rating">
                <img src={reviewStar} alt="Star 1"></img>
                <img src={reviewStar} alt="Star 2"></img>
                <img src={reviewStar} alt="Star 3"></img>
                <img src={reviewStar} alt="Star 4"></img>
                <img src={reviewStar} alt="Star 5"></img>
              </div>
              <p>"Their innovation boosted sales remarkably, their expertise and support are invaluable in our success".</p>
              <h4>&#x2022;&nbsp;&nbsp;&nbsp;Sarah j., CEO</h4>
            </div>
          </div>
          <div className="testimonial-comment">
            <div className="client-img">
              <img src={client2} alt="No img"></img>
            </div>
            <div className="client-content">
              <div className="star-rating">
                <img src={reviewStar} alt="Star 11"></img>
                <img src={reviewStar} alt="Star 22"></img>
                <img src={reviewStar} alt="Star 33"></img>
                <img src={reviewStar} alt="Star 44"></img>
                <img src={reviewStar} alt="Star 55"></img>
              </div>
              <p>"Their innovation boosted sales remarkably, their expertise and support are invaluable in our success".</p>
              <h4>&#x2022;&nbsp;&nbsp;&nbsp;Mark T., Team Entrepreneur</h4>
            </div>
          </div>
        </div>
        <button className="title-button title-button--secondary">Pricing</button>
        <div className="crm-testimonial-content">
          <h3>Explore Our Pricing Plans</h3>
          <p>Explore Our Pricing Plans Designed to Align with Your Business Goals and Budget.</p>
        </div>
        <div className="plan-switcher">
          <button onClick={() => handleSwitch('monthly')} className={`switch-button ${billingCycle === 'monthly' ? 'active' : ''}`}>
            Monthly
          </button>
          <button onClick={() => handleSwitch('yearly')} className={`switch-button ${billingCycle === 'yearly' ? 'active' : ''}`}>
            Yearly
          </button>
        </div>
        <div className="choosePlan-row">
          {selectedPlan.map((packages) => (
            <div className="choosePlan-box" key={packages.id}>
              <h3>{packages.name}</h3>
              <h2>
                ₹{packages.billing_amount}
                <span>/ {packages.billing_frequency}</span>
              </h2>
              <p>{packages.no_of_users} Users</p>
              <p>
                {[
                  packages.access_sales_module && "Sale",
                  packages.access_marketing_module && "Marketing",
                  packages.access_finance_module && "Finance",
                ]
                  .filter(Boolean)
                  .join(", ")}{" "}
              </p>
              <p>{packages.description}</p>
              <button onClick={() => handleGetStart(packages)} className="choosePlan-start-btn">
                Get Start
              </button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default CRMTestimonial;
